import React from 'react';
import styled from 'styled-components';
import { IconLink, IconFacebook, IconTwitterX, cssSpacing, cssColorValue, ButtonTertiary, } from '@spotify-internal/encore-web';
import { hexToRgba } from '../colorConversion';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const InlineShareButtons = styled.div `
  padding-bottom: ${cssSpacing('looser')};
  display: flex;
  flex-direction: row;
  a:focus:not(:disabled) {
    outline: 1px auto -webkit-focus-ring-color;
  }
  svg {
    cursor: pointer;
    color: ${({ textColor }) => textColor ? textColor : cssColorValue('textBase')};
    &:hover {
      color: ${({ textColor }) => textColor
    ? hexToRgba(textColor, 0.75)
    : hexToRgba(cssColorValue('textSubdued'))};
    }
  }
`;
const Wrapper = styled.div `
  padding-right: ${cssSpacing('base')};

  :last-of-type {
    padding-right: 0;
  }
`;
export const ShareButtonsComponent = ({ textColor = '', facebookShareLabel, twitterShareLabel, copyLinkLabel, shareUrl, }) => {
    const { InteractiveElement } = useFrodorModules();
    const TRACK_CAT = 'frodor_share';
    const currentShareUrl = shareUrl || (typeof window !== 'undefined' ? window.location.href : '');
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentShareUrl)}`;
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(currentShareUrl)}`;
    function copyToClipboard(e) {
        e.preventDefault();
        navigator.clipboard.writeText(currentShareUrl);
    }
    return (React.createElement(InlineShareButtons, { "data-testid": "share-buttons-container", textColor: textColor },
        React.createElement(Wrapper, null,
            React.createElement(InteractiveElement, { className: "button", customComponent: ButtonTertiary, iconOnly: IconFacebook, condensed: true, href: facebookShareUrl, target: "_blank", rel: "noopener noreferrer", "aria-label": facebookShareLabel, "data-testid": "share-buttons-facebook-icon", trackingLabel: "facebook", trackingCategory: TRACK_CAT })),
        React.createElement(Wrapper, null,
            React.createElement(InteractiveElement, { className: "button", customComponent: ButtonTertiary, iconOnly: IconTwitterX, condensed: true, href: twitterShareUrl, target: "_blank", rel: "noopener noreferrer", "aria-label": twitterShareLabel, "data-testid": "share-buttons-twitter-icon", trackingLabel: "twitter", trackingCategory: TRACK_CAT })),
        React.createElement(Wrapper, null,
            React.createElement(InteractiveElement, { className: "button", customComponent: ButtonTertiary, iconOnly: IconLink, condensed: true, onClick: copyToClipboard, "aria-label": copyLinkLabel, trackingLabel: "link_copy", trackingCategory: TRACK_CAT }))));
};
